import React, { FC } from "react";

import { ILinkProps } from "../../../ActionsSelectors/Link/Link";
import { LinkList } from "../../../ActionsSelectors/LinkList";

export interface IMobileBottomNavProps {
  /**
   * List of links to render
   */
  items?: ILinkProps[];
  /**
   * HTML label value
   */
  ariaLabel?: string;
}

/**
 * Helper layout component
 */
const MobileBottomNav: FC<IMobileBottomNavProps> = ({ items, ariaLabel }) => (
  <nav className="mobile-footer-nav" aria-label={ariaLabel}>
    <LinkList
      classes={{
        root: "mobile-footer-list",
        listItem: "mobile-footer-link mx-2",
        link: "mobile-footer-item ps-0 pe-0",
        activeLink: "mobile-footer-item--active",
      }}
      linksItems={items}
    />
  </nav>
);

export default MobileBottomNav;
